import { TweenLite } from "gsap/TweenMax"
if (document.querySelector("#our-vines-map")) {
    // const parallax = (element, resistance, mouse) => {
    //     TweenLite.to(element, 0.2, {
    //         x: -((mouse.clientX - window.innerWidth / 2) / resistance),
    //     })
    // }

    // document.addEventListener("mousemove", (e) => {
    //     if (document.querySelector(".vinery__svg")) parallax(document.querySelector(".vinery__svg"), 10, e)
    // })

    document.addEventListener("DOMContentLoaded", (e) => {
        let clickPaths = document.querySelectorAll(".otkl"),
            countMin = document.querySelector('.vinery__count-min'),
            countMax = document.querySelector('.vinery__count-max'),
            arrowPrev = document.querySelector('.vinery__arrow-prev'),
            arrowNext = document.querySelector('.vinery__arrow-next'),
            paths = document.querySelectorAll(
                "g.sauvignon, g.muscatWhite, g.aligote, g.plat, g.pinotBlanc, g.citrus, g.moldova, g.augustin, g.firstBorn, g.cardinalis, g.saperavi, g.risus, g.clairette, g.redGold, g.cimBlack, g.pinotNoir, g.bianca, g.hopeAzos, g.cabernetSauvignon, g.merlot, g.chardonnay",
            )
        
        
        
        if (paths.length)
            for (var path of paths)
                path.addEventListener("mouseover", function () {
                    let self = this,
                        title = document.querySelector(".vinery__title"),
                        hoverTitle = self.querySelector(".bluurspan h2").innerText


                    if (hoverTitle && title.innerText == hoverTitle) return

                    TweenLite.to(title, 0.2, {
                        opacity: 0,
                        onComplete() {
                            if(hoverTitle) {
                                title.innerText = hoverTitle
                            }

                            TweenLite.to(title, 0.2, {
                                opacity: 1,
                            })
                        },
                    })
                })

        if (!clickPaths.length) return

        countMax.textContent = clickPaths.length

        for (var path of clickPaths) {
            path.addEventListener("click", function () {
                changeSlide(this)
            })
        }

        arrowPrev.addEventListener('click', function() {
            changeSlideArrow(-1)
        })

        arrowNext.addEventListener('click', function() {
            changeSlideArrow(1)
        })

        function changeSlideArrow(number) {
            let numberSlide = Number(countMin.textContent) + number
            let self = document.querySelector(`[data-id="${numberSlide}"]`)
            
            changeSlide(self)
        }


        function changeSlide(self) {
            clickPaths.forEach((item) => item.classList.remove('active'))
            self.classList.add('active')
            
            document.querySelector(".vinery__text").innerHTML = self.querySelector(".bluurspan").innerHTML
            countMin.textContent = self.getAttribute('data-id')
            
            //Блокирование стрелочек при достижении краёв
            countMin.textContent == countMax.textContent ? arrowNext.classList.add('disabled') : arrowNext.classList.remove('disabled')
            countMin.textContent == 1 ? arrowPrev.classList.add('disabled') : arrowPrev.classList.remove('disabled')
        }
    })
}



// WEBPACK FOOTER //
// ./src/js/vinery.js